import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";
import type { EducationalAdvisorPendingActionsVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

const EMPTY_PENDING_ACTIONS: EducationalAdvisorPendingActionsVM = {
  hasActions: false,
  evaluations: { pendingCount: 0 },
  batches: { pendingCount: 0 },
};

export const selectEducationalAdvisorPendingActions = createSelector(
  [(state: AppState) => state.educationalAdvisor.pendingActionsRetrieval],
  ({ data, fetching }) => {
    if (fetching === "success" && data) {
      return data;
    }
    return EMPTY_PENDING_ACTIONS;
  },
);
